"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
exports.AcCloseIconButton = function () {
    var history = react_router_dom_1.useHistory();
    var onClickGoBack = function () {
        history.goBack();
    };
    return (react_1.default.createElement("div", { onClick: onClickGoBack, className: "p-2 fs-20 text-secondary d-inline-block", style: { cursor: 'pointer' } },
        react_1.default.createElement("i", { className: "far fa-times fs-18" })));
};
//# sourceMappingURL=AcCloseIconButton.js.map